import { render, staticRenderFns } from "./AttenDance.vue?vue&type=template&id=21124650&scoped=true"
import script from "./AttenDance.vue?vue&type=script&lang=js"
export * from "./AttenDance.vue?vue&type=script&lang=js"
import style0 from "./AttenDance.vue?vue&type=style&index=0&id=21124650&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21124650",
  null
  
)

export default component.exports